import { FC } from 'react';
import { GaugeLabelsProps } from '../../types';
import { GAUGE_STATUS_CONFIG } from './constants';
import {
  GaugeLabelsContainer,
  LabelTypography,
  StatusContainer,
  StatusTypography,
  ValueContainer,
  ValueInnerContainer,
  ValueTypography,
} from './styled';

export const GaugeLabels: FC<GaugeLabelsProps> = ({ label, value }) => {
  const getStatus = (value: number): string | null => {
    const statusConfig = GAUGE_STATUS_CONFIG.find(
      (config) => value >= config.threshold,
    );
    return statusConfig?.label || null;
  };

  const status = getStatus(value);

  return (
    <GaugeLabelsContainer hasStatus={!!status}>
      {status && (
        <StatusContainer>
          <StatusTypography variant="subtitle2">{status}</StatusTypography>
        </StatusContainer>
      )}
      <ValueContainer>
        <ValueInnerContainer gap={2}>
          <ValueTypography variant="subtitle1">{value}%</ValueTypography>
          <LabelTypography variant="caption">{label}</LabelTypography>
        </ValueInnerContainer>
      </ValueContainer>
    </GaugeLabelsContainer>
  );
};
